const white = '#ffffff';

export default white;
